import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=c808869e"
import script from "./BaseFilter.vue?vue&type=script&lang=ts"
export * from "./BaseFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports